'use client';

import { Button } from '@/components/primitives/Button';
import { trackOutboundClick } from '@/lib/analytics/trackEvent';

import type { ButtonProps } from '@/components/primitives/Button';
import type { GaLinkPlacement } from '@/constants/analytics';
import type { MouseEvent } from 'react';

type TrackedOutboundButtonProps = Extract<ButtonProps, { href: string }> & {
  linkPlacement: GaLinkPlacement;
};

/**
 * Client leaf wrapping `Button` (anchor) to fire `outbound_click` without
 * promoting a parent layout shell to `'use client'`.
 */
export function TrackedOutboundButton({
  href,
  linkPlacement,
  onClick,
  ...buttonProps
}: TrackedOutboundButtonProps) {
  return (
    <Button
      {...buttonProps}
      href={href}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        trackOutboundClick({ href, linkPlacement });
        onClick?.(event);
      }}
    />
  );
}
